import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  constructor(
    public authService: AuthService,
    private readonly http: HttpClient
  ) {}
  canShowLeadNotification = false;
}
